// Global Instructions Rule Applied!
import { useCallback, useEffect, useState } from 'react'
import { getAccessToken } from '../../../core/auth/authService'
import { store } from '../../../state_manager/store.ts'
import { showErrorToast } from '../../../core/utils/errorToast.tsx'
import { AccountOwnerRecord } from '../../../state_manager/data_models/relationships_model.ts'
import { fetchAccountOwners } from '../services/relationshipsService.ts'

// Owners of one account. The token is read at CALL time (never bound in a
// component body — the follower-agents 403 lesson).
export function useAccountOwners(accountId: string | null | undefined) {
  const [owners, setOwners] = useState<AccountOwnerRecord[]>([])
  const [loading, setLoading] = useState(false)

  const refetch = useCallback(async () => {
    if (!accountId) {
      setOwners([])
      return
    }
    setLoading(true)
    try {
      setOwners(await fetchAccountOwners(accountId, getAccessToken(store.getState().auth)))
    } catch (e) {
      showErrorToast(e instanceof Error ? e.message : 'Failed to load owners')
    } finally {
      setLoading(false)
    }
  }, [accountId])

  useEffect(() => {
    refetch()
  }, [refetch])

  return { owners, loading, refetch }
}
